/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/require-default-props */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useAuth } from "../../hooks/auth";

import { decodeToken } from "../../utils/jwt";

export const MenuBoepm: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawerOpen = (): void => setDrawerOpen(!drawerOpen);
  const { pathname } = useLocation();
  const { user } = useAuth();

  const sistema = decodeToken(user?.token as string);
  const boOme = sistema.sistemas.find((s: number) => s === 5);
  const boGeral = sistema.sistemas.find((s: number) => s === 10);

  const theme = MUI.useTheme();
  const mdDown = MUI.useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {mdDown ? (
        <MUI.Box>
          <MUI.IconButton onClick={toggleDrawerOpen}>
            <Icon.Menu />
          </MUI.IconButton>
          <MUI.Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawerOpen}
          >
            <MUI.Box
              display="flex"
              flexDirection="column"
              height="100%"
              width={theme.spacing(28)}
              bgcolor={theme.palette.primary.light}
              sx={{
                displayPrint: "none",
              }}
            >
              <MUI.List>
                <MUI.Typography
                  sx={{ color: "#fff !important" }}
                  variant="h6"
                  textAlign="center"
                >
                  BO's do usuário
                </MUI.Typography>

                <MUI.ListItemButton
                  component={Link}
                  to="/boepm/bos-do-usuario-ocorrencia"
                  selected={pathname === "/boepm/bos-do-usuario-ocorrencia"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.Article sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Mike
                  </MUI.ListItemText>
                </MUI.ListItemButton>

                <MUI.ListItemButton
                  component={Link}
                  to="/boepm/bos-do-usuario-data"
                  selected={pathname === "/boepm/bos-do-usuario-data"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.Article sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Data
                  </MUI.ListItemText>
                </MUI.ListItemButton>

                {!boGeral && boOme ? (
                  <>
                    <MUI.Typography
                      sx={{ color: "#fff !important" }}
                      variant="h6"
                      textAlign="center"
                    >
                      BO's da OME
                    </MUI.Typography>

                    <MUI.ListItemButton
                      component={Link}
                      to="/boepm/bos-da-ome-ocorrencia"
                      selected={pathname === "/boepm/bos-da-ome-ocorrencia"}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: `${theme.palette.primary.main}`,
                          "&.Mui-focusVisible": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                          ":hover": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                        },
                      }}
                    >
                      <MUI.ListItemIcon>
                        <Icon.Article sx={{ color: "white" }} />
                      </MUI.ListItemIcon>
                      <MUI.ListItemText sx={{ color: "white" }}>
                        Mike
                      </MUI.ListItemText>
                    </MUI.ListItemButton>

                    <MUI.ListItemButton
                      component={Link}
                      to="/boepm/bos-da-ome-data"
                      selected={pathname === "/boepm/bos-da-ome-data"}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: `${theme.palette.primary.main}`,
                          "&.Mui-focusVisible": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                          ":hover": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                        },
                      }}
                    >
                      <MUI.ListItemIcon>
                        <Icon.Article sx={{ color: "white" }} />
                      </MUI.ListItemIcon>
                      <MUI.ListItemText sx={{ color: "white" }}>
                        Data
                      </MUI.ListItemText>
                    </MUI.ListItemButton>
                  </>
                ) : (
                  false
                )}

                {boGeral ? (
                  <>
                    <MUI.Typography
                      sx={{ color: "#fff !important" }}
                      variant="h6"
                      textAlign="center"
                    >
                      BO's por OME
                    </MUI.Typography>

                    <MUI.ListItemButton
                      component={Link}
                      to="/boepm/bos-por-ome-ocorrencia"
                      selected={pathname === "/boepm/bos-por-ome-ocorrencia"}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: `${theme.palette.primary.main}`,
                          "&.Mui-focusVisible": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                          ":hover": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                        },
                      }}
                    >
                      <MUI.ListItemIcon>
                        <Icon.Article sx={{ color: "white" }} />
                      </MUI.ListItemIcon>
                      <MUI.ListItemText sx={{ color: "white" }}>
                        Mike
                      </MUI.ListItemText>
                    </MUI.ListItemButton>

                    <MUI.ListItemButton
                      component={Link}
                      to="/boepm/bos-por-ome-data"
                      selected={pathname === "/boepm/bos-por-ome-data"}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: `${theme.palette.primary.main}`,
                          "&.Mui-focusVisible": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                          ":hover": {
                            backgroundColor: `${theme.palette.primary.dark}`,
                          },
                        },
                      }}
                    >
                      <MUI.ListItemIcon>
                        <Icon.Article sx={{ color: "white" }} />
                      </MUI.ListItemIcon>
                      <MUI.ListItemText sx={{ color: "white" }}>
                        Data
                      </MUI.ListItemText>
                    </MUI.ListItemButton>
                  </>
                ) : (
                  false
                )}

                <MUI.ListItemButton component={Link} to="/pagina-inicial">
                  <MUI.ListItemIcon>
                    <Icon.KeyboardReturn sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Voltar página inicial
                  </MUI.ListItemText>
                </MUI.ListItemButton>
              </MUI.List>
            </MUI.Box>
          </MUI.Drawer>
        </MUI.Box>
      ) : (
        <MUI.Box
          display="flex"
          flexDirection="column"
          height="100%"
          width={theme.spacing(30)}
          bgcolor={theme.palette.primary.light}
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.List>
            <MUI.Typography
              sx={{ color: "#fff !important" }}
              variant="h6"
              textAlign="center"
            >
              BO's do usuário
            </MUI.Typography>

            <MUI.ListItemButton
              component={Link}
              to="/boepm/bos-do-usuario-ocorrencia"
              selected={pathname === "/boepm/bos-do-usuario-ocorrencia"}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: `${theme.palette.primary.main}`,
                  "&.Mui-focusVisible": {
                    backgroundColor: `${theme.palette.primary.dark}`,
                  },
                  ":hover": {
                    backgroundColor: `${theme.palette.primary.dark}`,
                  },
                },
              }}
            >
              <MUI.ListItemIcon>
                <Icon.Article sx={{ color: "white" }} />
              </MUI.ListItemIcon>
              <MUI.ListItemText sx={{ color: "white" }}>Mike</MUI.ListItemText>
            </MUI.ListItemButton>

            <MUI.ListItemButton
              component={Link}
              to="/boepm/bos-do-usuario-data"
              selected={pathname === "/boepm/bos-do-usuario-data"}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: `${theme.palette.primary.main}`,
                  "&.Mui-focusVisible": {
                    backgroundColor: `${theme.palette.primary.dark}`,
                  },
                  ":hover": {
                    backgroundColor: `${theme.palette.primary.dark}`,
                  },
                },
              }}
            >
              <MUI.ListItemIcon>
                <Icon.Article sx={{ color: "white" }} />
              </MUI.ListItemIcon>
              <MUI.ListItemText sx={{ color: "white" }}>Data</MUI.ListItemText>
            </MUI.ListItemButton>

            {!boGeral && boOme ? (
              <>
                <MUI.Typography
                  sx={{ color: "#fff !important" }}
                  variant="h6"
                  textAlign="center"
                >
                  BO's da OME
                </MUI.Typography>

                <MUI.ListItemButton
                  component={Link}
                  to="/boepm/bos-da-ome-ocorrencia"
                  selected={pathname === "/boepm/bos-da-ome-ocorrencia"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.Article sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Mike
                  </MUI.ListItemText>
                </MUI.ListItemButton>

                <MUI.ListItemButton
                  component={Link}
                  to="/boepm/bos-da-ome-data"
                  selected={pathname === "/boepm/bos-da-ome-data"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.Article sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Data
                  </MUI.ListItemText>
                </MUI.ListItemButton>
              </>
            ) : (
              false
            )}

            {boGeral ? (
              <>
                <MUI.Typography
                  sx={{ color: "#fff !important" }}
                  variant="h6"
                  textAlign="center"
                >
                  BO's por OME
                </MUI.Typography>

                <MUI.ListItemButton
                  component={Link}
                  to="/boepm/bos-por-ome-ocorrencia"
                  selected={pathname === "/boepm/bos-por-ome-ocorrencia"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.Article sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Mike
                  </MUI.ListItemText>
                </MUI.ListItemButton>

                <MUI.ListItemButton
                  component={Link}
                  to="/boepm/bos-por-ome-data"
                  selected={pathname === "/boepm/bos-por-ome-data"}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.Article sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Data
                  </MUI.ListItemText>
                </MUI.ListItemButton>
              </>
            ) : (
              false
            )}

            <MUI.ListItemButton component={Link} to="/pagina-inicial">
              <MUI.ListItemIcon>
                <Icon.KeyboardReturn sx={{ color: "white" }} />
              </MUI.ListItemIcon>
              <MUI.ListItemText sx={{ color: "white" }}>
                Voltar página inicial
              </MUI.ListItemText>
            </MUI.ListItemButton>
          </MUI.List>
        </MUI.Box>
      )}
    </>
  );
};

export default React.memo(MenuBoepm);
